import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '../hosts';
import useGetFetchConfig from '../useGetFetchConfig';

interface UseDownloadDocumentProps {
  caseId: string;
  docId: string;
  fileName?: string;
  highlighted?: boolean;
}

export const useDownloadDocument = ({ caseId, docId, fileName, highlighted = false }: UseDownloadDocumentProps) => {
  const { fetchConfigGET } = useGetFetchConfig();

  const downloadDocument = async () => {
    try {
      // Fetch the presigned URL with highlighted parameter
      const urlResponse = await fetch(
        `${APIBaseChronos}/api/case/${caseId}/docs/${docId}/download?highlighted=${highlighted}`,
        fetchConfigGET,
      );

      if (!urlResponse.ok) {
        throw new Error(`Failed to get ${highlighted ? 'highlighted ' : ''}document URL`);
      }

      const presignedUrl = await urlResponse.text();

      // Create a download link and trigger it
      const link = document.createElement('a');
      link.href = presignedUrl;
      link.target = '_blank';

      // Set the filename for the download
      if (fileName) {
        link.download = fileName;
      } else {
        link.download = `wexler-document-${docId}`;
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download failed:', error);
      throw error;
    }
  };

  return useMutation(downloadDocument, {
    onError: () => {
      toast.error(`Failed to download ${highlighted ? 'highlighted ' : ''}document`);
    },
  });
};
